import { type ReactElement } from 'react';

import classNames from 'classnames';

import styles from './Checkbox.module.scss';

const Checkbox = ({
  icon,
  id,
  dataTestId,
  checked,
  className,
  onChange,
  required,
}: {
  icon: ReactElement;
  id?: string;
  dataTestId?: string;
  checked: boolean;
  className?: string;
  onChange: (checked: boolean) => void;
  required?: boolean;
}) => {
  return (
    <div className={classNames(styles.formRow, className)}>
      <input
        checked={checked}
        className={styles.checkbox}
        data-testid={dataTestId}
        id={id}
        required={required}
        type="checkbox"
        onChange={(event) => onChange(event.target.checked)}
      />
      {checked && (
        <label className={styles.icon} htmlFor={id}>
          {icon}
        </label>
      )}
    </div>
  );
};

export default Checkbox;
